import { useState } from 'react';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useNotify } from 'react-admin';
import { CancelButton, SaveButton } from 'shared/mui/Buttons';
import { TypographyWithBold } from 'shared/mui/Typography';
import { CreateGuesserPage } from 'shared/react-admin/Pages/CreateGuesserPage/CreateGuesserPage';
import { Merchant } from 'types/embedded/merchant';

import { CreatedSuccessDialog } from './components/CreatedSuccessDialog/CreatedSuccessDialog';
import { MerchantsCreateForm } from './MerchantsCreateForm';

export const MerchantsCreate: React.FC = () => {
  const translate = useTypedTranslate();
  const notify = useNotify();
  const [createdMerchant, setCreatedMerchant] = useState<Merchant | null>(null);

  const onSuccess = (merchant: Merchant) => {
    notify(
      <TypographyWithBold
        text={translate('app.merchants.merchantCreated', { name: merchant.name })}
      />,
      { type: 'success' },
    );
    setCreatedMerchant(merchant);
  };

  return (
    <CreateGuesserPage
      listName="Мерчанты"
      mutationOptions={{
        onError: () => undefined,
        onSuccess,
      }}
      rightActionsSlot={[
        <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
        <SaveButton key="save-button" />,
      ]}
      title="Создание мерчанта"
    >
      <MerchantsCreateForm />
      {createdMerchant && <CreatedSuccessDialog merchant={createdMerchant} />}
    </CreateGuesserPage>
  );
};
